<template lang="pug">
    flexLink(:to="link" class="group no-underline cursor-pointer")
        div(class="image-box bg-white border border-solid border-gray-light p-2 h-16 flex justify-center items-center flex-col md:h-24 group-hover:border-gray group-focus:border-gray")
            slot(name="image")
                img(v-if="imageSrc" :src="imageSrc" :alt="text" class="h-full object-contain")
        div(v-if="text" class="text-gray-darkest text-sm text-center pt-1 group-hover:text-black group-focus:text-black") {{ text }}
</template>
<script>
import flexLink from '@/components/flexLink'

export default {
    components: {
        flexLink,
    },
    props: {
        /** linkBuilder object */
        link: {
            type: Object,
            required: true,
        },
        /** You may pass in an img src or slot in your own img tag */
        imageSrc: {
            type: String,
            default: null,
        },
        /** Text to display under the image and as Alt */
        text: {
            type: String,
            default: null,
        },
    },
}
</script>
